export default __webpack_public_path__ + "static/media/rabobank.f60133da.svg";